import { useApp } from '../../context/AppContext';
import './Pages.css';

const Privacy = () => {
  const { setCurrentView } = useApp();

  return (
    <div className="page-container">
      <div className="page-header">
        <button className="btn btn-ghost" onClick={() => setCurrentView('upload')}>
          ← Back to Home
        </button>
        <h1>Privacy Policy</h1>
      </div>

      <div className="page-content legal-content">
        <p className="legal-updated">Last updated: January 2025</p>

        <section className="legal-section">
          <h2>Our Commitment to Privacy</h2>
          <p>
            At GoSplitPDF, we take your privacy seriously. This policy explains how we handle
            your data when you use our service.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Processing</h2>
          <h3>Client-Side Processing</h3>
          <p>
            The majority of our PDF tools process your files directly in your browser. This means:
          </p>
          <ul>
            <li>Your files never leave your device</li>
            <li>No data is transmitted to our servers</li>
            <li>Files are not stored anywhere after you close the browser</li>
          </ul>

          <h3>Server-Side Processing</h3>
          <p>
            Some features (Word, Excel, PowerPoint conversion) require server processing. For these:
          </p>
          <ul>
            <li>Files are encrypted during transmission using HTTPS</li>
            <li>Files are processed immediately upon receipt</li>
            <li>Files are automatically deleted after conversion completes</li>
            <li>No copies are retained on our servers</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Information We Collect</h2>
          <h3>Analytics</h3>
          <p>
            We use Google Analytics to understand how visitors use our site. This collects:
          </p>
          <ul>
            <li>Pages visited and time spent</li>
            <li>Browser type and device information</li>
            <li>General geographic location (country/region level)</li>
            <li>Referral sources</li>
          </ul>
          <p>
            This data is aggregated and does not identify individual users. You can opt out of
            Google Analytics by using browser extensions or privacy settings.
          </p>

          <h3>Local Storage</h3>
          <p>
            We use browser local storage to save your preferences (like settings). This data
            remains on your device and is never transmitted to us.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Form</h2>
          <p>
            When you use our contact form, we collect the information you provide (name, email,
            message). This information is used solely to respond to your inquiry and is not
            shared with third parties.
          </p>
        </section>

        <section className="legal-section">
          <h2>Cookies</h2>
          <p>
            We use essential cookies for site functionality and analytics cookies to understand
            usage patterns. You can control cookie preferences through your browser settings.
          </p>
        </section>

        <section className="legal-section">
          <h2>Third-Party Services</h2>
          <p>We use the following third-party services:</p>
          <ul>
            <li><strong>Google Analytics:</strong> Website analytics</li>
            <li><strong>Netlify:</strong> Hosting and form processing</li>
          </ul>
          <p>
            Each service has its own privacy policy governing their data practices.
          </p>
        </section>

        <section className="legal-section">
          <h2>Data Security</h2>
          <p>
            We implement appropriate security measures including:
          </p>
          <ul>
            <li>HTTPS encryption for all data transmission</li>
            <li>Regular security updates and monitoring</li>
            <li>Minimal data collection practices</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Know what data we collect about you</li>
            <li>Request deletion of any personal data</li>
            <li>Opt out of analytics tracking</li>
            <li>Contact us with privacy concerns</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>Changes to This Policy</h2>
          <p>
            We may update this privacy policy periodically. Changes will be posted on this page
            with an updated revision date.
          </p>
        </section>

        <section className="legal-section">
          <h2>Contact Us</h2>
          <p>
            For privacy-related questions or concerns, please{' '}
            <button className="link-button" onClick={() => setCurrentView('contact')}>
              contact us
            </button>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Privacy;
